/** Belgeler, eksik evrak ve bordro pusulası metinleri. */
export const documents = {
  category: {
    identity: "Kimlik ve ikamet",
    education: "Eğitim",
    health: "Sağlık",
    contract: "Sözleşme ve yasal",
    payroll: "Bordro ve banka",
    certificate: "Sertifika",
    other: "Diğer",
  },
  sensitivity: {
    normal: "Standart",
    special: "Özel nitelikli",
    specialHint: "Özel nitelikli kişisel veri. Yalnızca çalışanın kendisi ve yetkili İK görebilir; her açılış kayda geçer.",
  },
  status: {
    pending_review: "İncelemede",
    accepted: "Kabul edildi",
    rejected: "Reddedildi",
    archived: "Arşivde",
  },
  expiry: {
    expired: "Süresi doldu",
    expiring: "Süresi yaklaşıyor",
    validUntil: "Geçerlilik: {date}",
  },
  request: {
    status: { open: "Bekleniyor", fulfilled: "Yüklendi", cancelled: "İptal edildi" },
    due: "Son tarih: {date}.",
    overdue: "Son tarih geçti",
  },
  missing: {
    reason: {
      required: "Tüm çalışanlardan istenen belge",
      requested: "İK ekibi istedi",
      expired: "Süresi doldu, yenisi gerekiyor",
    },
    state: {
      missing: "Henüz yüklenmedi",
      in_review: "Yüklendi, İK inceliyor",
      rejected: "Reddedildi, yeniden yükleyin",
    },
    emptyMine: "Sizden istenen belge yok. Her şey tamam.",
    emptyAll: "Eksik belge yok.",
  },
  review: {
    accept: "Kabul et",
    reject: "Reddet",
    rejectNoteHint: "Neyin eksik olduğunu yazın; çalışan bu notu görecek.",
  },
  /** Bildirimlerde (kilit ekranı, e-posta) özel nitelikli tür adı yerine kullanılır. */
  notify: {
    specialType: "Özel nitelikli bir belge",
    detailsInApp: "Ayrıntıları uygulamada görebilirsiniz.",
  },
  retention:
    "Belgeler silinmez, arşivlenir. Arşivdeki belgeler yasal saklama süresi boyunca korunur ve yalnızca yetkili İK görebilir; süre dolunca güvenli biçimde imha edilir.",
  /** Hata ayrıntısı (`error.details.reason`) için daha açıklayıcı metinler. */
  errors: {
    no_employee_record: "Hesabınıza bağlı bir çalışan kaydı yok. İK ekibinizden kaydınızı bağlamasını isteyin.",
    type_not_uploadable: "Bu belge türünü kendiniz yükleyemezsiniz. Belgeyi İK ekibinize iletin; sizden istendiğinde buradan yükleyebilirsiniz.",
    type_archived: "Bu belge türü artık kullanılmıyor. Uygun başka bir tür seçin.",
    file_invalid: "Dosya bulunamadı ya da başka bir kayda bağlı. Dosyayı yeniden yükleyip tekrar deneyin.",
    expiry_required: "Bu belge türü için geçerlilik bitiş tarihini girin.",
    already_reviewed: "Bu belge zaten incelenmiş. Listeyi yenileyip güncel durumu görün.",
    archived: "Arşivdeki belge üzerinde işlem yapılamaz.",
    special_requires_permission: "Özel nitelikli belgeler için yetkiniz yok. İK yöneticinize başvurun.",
    request_exists: "Bu çalışandan bu belge zaten istenmiş. Mevcut talebi kullanın ya da iptal edip yenisini oluşturun.",
    request_closed: "Bu talep zaten kapanmış.",
    employee_terminated: "Ayrılmış çalışandan belge istenemez.",
    duplicate_type: "Bu adla bir belge türü zaten var. Farklı bir ad seçin.",
    already_published: "Yayınlanmış pusula değiştirilemez. Düzeltme için yeni dosya yükleyin; yenisi eskisinin yerine geçer.",
    replaced: "Bu pusulanın yerine daha yenisi yüklenmiş.",
  },
  payslip: {
    defaultTitle: "{period} bordroları",
    batchStatus: { draft: "Taslak", published: "Yayınlandı" },
    matchedBy: {
      employee_number: "Sicil no ile eşleşti",
      national_id: "TC kimlik no ile eşleşti",
      manual: "Elle eşleştirildi",
      unmatched: "Eşleşmedi",
      replaced: "Yerine yenisi yüklendi",
    },
    unmatchedReason: {
      no_identifier: "Dosya adında sicil no ya da TC kimlik no yok. Çalışanı elle seçin.",
      not_found: "Dosya adındaki numara hiçbir çalışanla eşleşmedi. Çalışanın sicil no veya TC kimlik no kaydını kontrol edin ya da elle eşleştirin.",
      ambiguous: "Dosya adı birden fazla çalışanla eşleşiyor. Doğru çalışanı elle seçin.",
    },
    rejected: {
      not_found: "Dosya bulunamadı. Bordro dosyası olarak yeniden yükleyin.",
      not_pdf: "Bordro pusulası PDF olmalı.",
      already_attached: "Bu dosya zaten bir bordro kaydına bağlı.",
    },
    publishConfirm_one: "{count} çalışana pusulası yayınlanacak ve bildirim gidecek.",
    publishConfirm_other: "{count} çalışana pusulası yayınlanacak ve bildirim gidecek.",
    unmatchedWarning_one: "{count} dosya eşleşmedi; yayınlanmayacak.",
    unmatchedWarning_other: "{count} dosya eşleşmedi; yayınlanmayacak.",
    acknowledge: "Teslim aldım",
    acknowledgedOn: "Teslim alındı: {date}",
    viewed: "Görüntülendi",
    notViewed: "Henüz açılmadı",
    empty: "Henüz yayınlanmış bordronuz yok.",
    privacy: "Bordronuzu yalnızca siz ve bordrodan sorumlu yetkililer görebilir; her açılış kayda geçer.",
  },
};
